import React from 'react';

import SubCategoryInlineList from './components/inline-list';
import SubCategoryList from './components/list';
import type { Category } from './types';

interface SubcategoryListingProps {
  styling: 'inline-list' | 'list';
  brands?: Category[];
  categories?: { nodes: Category[] };
  limit?: number;
  collapse?: boolean;
}

const SubCategoryListing: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<SubcategoryListingProps>>
> = props => {
  const { styling } = props;
  const categories = [
    ...(props.brands ?? []),
    ...(props.categories?.nodes ?? []),
  ];
  if (categories.length === 0) {
    return null;
  }
  switch (styling) {
    case 'inline-list': {
      return <SubCategoryInlineList {...props} categories={categories} />;
    }
    case 'list': {
      return <SubCategoryList {...props} categories={categories} />;
    }
    default:
      return null;
  }
};

export default SubCategoryListing;
